module.exports = __webpack_public_path__ + "static/img/train_none.3884631.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/train_none.png
// module id = 49x7
// module chunks = 1